import { useEffect } from 'react';

import { useIsMobile } from './useIsMobile';
import useInterval from './useInterval';
export { useIsMobile, useInterval };

export const useHandleFieldArrayRemove = (
  value: string | undefined,
  callback: (value: string) => void
): void => {
  useEffect(() => {
    if (!value) return;
    callback(value);
  }, [value, callback]);
};
